import { array, object, string } from "yup";

import { makeStyles } from "@material-ui/core";

export const useStyleFormAssignDoc = makeStyles(theme => ({
    border: {
        border: "1px solid rgba(0, 0, 0, 0.23)",
    },
    select: {
        "& .MuiOutlinedInput-inputMarginDense": {
            paddingTop: 13,
            paddingBottom: 13,
        },
    },
    input: {
        "& .MuiOutlinedInput-inputMarginDense": {
            paddingTop: 13,
            paddingBottom: 13,
        },
        "& .MuiInputLabel-formControl": {
            top: 3,
            color: "#dfdfdf !important",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderWidth: "1px !important",
        },
    },
    autoComplete: {
        "& .MuiInputBase-root.MuiOutlinedInput-root": {
            paddingTop: 9.4,
            paddingBottom: 9.4,
        },
    },
}));

export const initialRoomDoctorTableOptions = {
    pageSize: 5,
    pageSizeOptions: [5, 10, 20, 50],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    headerStyle: {
        fontSize: 15,
    },
    debounceInterval: 500,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};

export const roomDoctorTableColumns = [
    {
        field: "Doctor.Doctorname",
        title: "Doctor",
    },
    {
        field: "dayRoom",
        title: "Day",
        render: row => {
            const day = JSON.parse(row?.dayRoom);
            return day.join(", ");
        },
    },
    {
        field: "moment",
        title: "Section",
        render: row => {
            if (row?.moment === "0") {
                return "เช้า";
            } else if (row?.moment === "1") {
                return "บ่าย";
            } else if (row?.moment === "2") {
                return "ค่ำ";
            } else {
                return "";
            }
        },
    },
];

export const initialValueFormAssignDoc = {
    codeDoc: "",
    days: [],
    period: "",
    roomDoctorId: "",
};

export const validateSchemaFormAssignDoc = object({
    codeDoc: string().required("Required."),
    days: array().min(1, "Please select at least 1"),
    period: string().required("Required."),
});
